// extracted by mini-css-extract-plugin
module.exports = {"infoSection":"InfoSection_infoSection__R4DIc","border":"InfoSection_border__pz9li","swatches":"InfoSection_swatches__p9V_c"};